import { ArrowLeft } from "lucide-react";
import { Link, useRouter } from "@tanstack/react-router";
import type { MouseEvent } from "react";

type Props = {
  to: string;
  label: string;
  className?: string;
};

/**
 * "Volver al portal" link that prefers browser back navigation so the
 * portal's URL-encoded filters are preserved. Falls back to a normal
 * Link to the portal index when there is no previous SPA history entry.
 */
export function BackToPortal({ to, label, className }: Props) {
  const router = useRouter();

  const handleClick = (e: MouseEvent) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof window === "undefined") return;
    // router.history.length > 1 means there is a previous SPA entry to return to.
    if (router.history.length > 1) {
      e.preventDefault();
      router.history.back();
    }
  };

  return (
    <Link to={to} className={className} onClick={handleClick}>
      <ArrowLeft className="h-4 w-4" /> {label}
    </Link>
  );
}
